<template>
  <layout-basic>

      <h3 class="title is-4">Projects</h3>

      <button class="button is-primary " @click="cardModal()">
        Add new
      </button>
      <b-table
        :data="projects"
        :striped="true"
      >

        <b-table-column field="name" label="Name"  v-slot="props">
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field="name" label="Status"  v-slot="props">
          <div v-if="props.row.testJobs.length === 0">
            <b-tag class="is-light is-medium is-success">Success</b-tag>
          </div>
          <div v-else>
            <b-tag class="is-light is-medium is-danger">Has failed test</b-tag>
          </div>
        </b-table-column>

        <b-table-column field="actions" v-slot="props" cell-class="has-text-right">
          <button class="button is-small is-info" @click="viewProject(props.row._id)">
            <b-icon icon="eye" size="is-small"></b-icon>
          </button>

          <button class="button is-small is-danger ml-2" @click="deleteProject(props.row._id)">
            <b-icon icon="trash-alt" size="is-small"></b-icon>
          </button>
        </b-table-column>

        <template slot="empty">
          <p>No projects created, yet</p>
        </template>
      </b-table>

  </layout-basic>
</template>
<script>

import LayoutBasic from '@/layouts/LayoutBasic'
import ProjectService from '@/services/ProjectService'
import NewProjectModal from '@/components/Project/NewProjectModal'

export default {
  name: 'Projects',
  components: {
    LayoutBasic
  },
  created () {
    this.getProjectList();
  },
  data () {
    return {
      projects: [],
    }
  },

  methods: {
    getProjectList() {
      ProjectService.getList().then((response) => {
        this.projects = response.data;
      }).catch((e) => {
        console.log(e);
      })
    },
    cardModal() {
      this.$buefy.modal.open({
        parent: this,
        component: NewProjectModal,
        hasModalCard: true,
        trapFocus: true,
      })
    },
    viewProject(projectId) {
      this.$router.push({ path: '/project/' + projectId })
    },
    deleteProject(projectId) {
      ProjectService.delete(projectId).then(response => {
        this.getProjectList();
      })
    }
  }
}
</script>
